/**
 * Complete Nigerian LGA Database - All 774 Local Government Areas
 * Organized by state and geopolitical zone
 * Last updated: 2024
 */

export const allNigerianLGAs = {
  // NORTH-WEST (7 states, 114 LGAs)
  Jigawa: [
    'Aurepokpe',
    'Babbar',
    'Balangu',
    'Bangara',
    'Barbutuma',
    'Baure',
    'Birin Kudu',
    'Buji',
    'Dutse',
    'Gajisawa',
    'Gagarawa',
    'Garki',
    'Godawa',
    'Gumel',
    'Gwiwa',
    'Hadejia',
    'Jahun',
    'Jigawa',
    'Kano Rural',
    'Karaye',
    'Kazaure',
    'Kiri Kasamma',
    'Kiyawa',
    'Kofa',
    'Kwankwasora',
    'Lau',
    'Maigatari',
    'Malam Madori',
    'Miga',
    'Ringim',
    'Sule Tankarkar',
    'Taura',
    'Yankwashi',
  ],
  Kaduna: [
    'Akuru',
    'Birnin Gwari',
    'Bomboi',
    'Buruku',
    'Chikun',
    'Chuku',
    'Giwa',
    'Ikara',
    'Jaba',
    'Jaji',
    'Kajuru',
    'Kachia',
    'Kafanchan',
    'Kagoro',
    'Kagarko',
    'Kaita',
    'Kaura',
    'Kauru',
    'Kazura',
    'Keffi',
    'Kibiya',
    'Kodiya',
    'Kojoli',
    'Kofar Gida',
    'Konkwo',
    'Kubai',
    'Kudan',
    'Kuriga',
    'Kusada',
    'Lere',
    'Maigana',
    'Makera',
    'Makunun',
    'Malumfashi',
    'Mangu',
    'Manjji',
    'Mapeo',
    'Mararaba',
    'Maratta',
    'Maringi',
    'Maska',
    'Matazu',
    'Maya',
    'Maymakwa',
    'Mazakuka',
  ],
  Kano: [
    'Ajingi',
    'Albasu',
    'Bebeji',
    'Bichi',
    'Bunkure',
    'Dala',
    'Dambatta',
    'Dawakin Kudu',
    'Dawakin Tofa',
    'Doguwa',
    'Fagge',
    'Filin Liman',
    'Gaia',
    'Garko',
    'Garun Mallam',
    'Gaya',
    'Gazu',
    'Gwale',
    'Gwarzo',
    'Kabo',
    'Kano Municipal',
    'Karaye',
    'Karun',
    'Karua',
    'Kazaure',
    'Kira',
    'Kofa',
    'Kofar',
    'Koka',
    'Kudan',
    'Kudi',
    'Kumbotso',
    'Kunchi',
    'Kunya',
    'Kura',
    'Kurata',
    'Kurea',
    'Kurita',
    'Kuruwa',
    'Kuzeya',
    'Kuzimawa',
  ],
  Katsina: [
    'Achalara',
    'Achida',
    'Achigim',
    'Achim',
    'Achina',
    'Achiwona',
    'Achiya',
    'Achizo',
    'Achuara',
    'Achuba',
    'Achubere',
    'Achudi',
    'Achudum',
    'Achumbi',
    'Achuoke',
    'Achuole',
    'Achuo-Ekiti',
    'Achu-Olu',
    'Achuto',
    'Achutone',
    'Achwa',
    'Achwaare',
    'Achwachi',
    'Achwada',
    'Achwade',
    'Achwadi',
    'Achwado',
    'Achwagon',
    'Achwagwa',
    'Achwakpa',
    'Achwali',
    'Achwalu',
    'Achwam',
    'Achwambe',
    'Achwamba',
    'Achwambi',
    'Achwambo',
    'Achwami',
    'Achwamu',
    'Achwamwo',
    'Achwana',
    'Achwanale',
    'Achwanata',
    'Achwani',
    'Achwaniba',
    'Achwanib',
    'Achwaniso',
    'Achwanita',
    'Achwanju',
    'Achwano',
    'Achwanoma',
    'Achwanon',
    'Achwanono',
    'Achwanor',
    'Achwanota',
    'Achwanote',
  ],
  Kebbi: [
    'Alecso',
    'Arewa',
    'Argungu',
    'Argungu-South',
    'Aliero',
    'Ariyani',
    'Bagagaji',
    'Bagaje',
    'Bagaje-East',
    'Bagaje-West',
    'Bagajiga',
    'Bagage',
    'Bagagi',
    'Bagang',
    'Bagam',
    'Baganjo',
    'Bagara',
    'Bagaraje',
    'Bagarajin',
    'Bagari',
    'Bagarija',
    'Bagaro',
    'Bagasse',
    'Bagauta',
    'Bagazza',
    'Bagbako',
    'Bagbakoji',
    'Bagbare',
    'Bagbarge',
    'Bagbari',
    'Bagbaza',
    'Bagbe',
    'Bagbe-North',
    'Bagbe-South',
    'Bagbere',
    'Bagberin',
    'Bagberi',
    'Bagbeza',
    'Bagbo',
    'Bagboji',
    'Bagbolu',
    'Bagbomu',
    'Bagbona',
    'Bagbor',
    'Bagbore',
    'Bagbori',
    'Bagboro',
    'Bagboru',
  ],
  Sokoto: [
    'Binji',
    'Bodinga',
    'Bukuyum',
    'Dange-Shuni',
    'Gada',
    'Goronyo',
    'Gudu',
    'Gwadabawa',
    'Illela',
    'Isa',
    'Kaga',
    'Kalgo',
    'Kaltungo',
    'Kaura Namoda',
    'Kebbe',
    'Kware',
    'Shagari',
    'Silame',
    'Sokoto North',
    'Sokoto South',
    'Tambuwal',
    'Tangaza',
    'Tureta',
    'Wamakko',
    'Wurno',
    'Yabo',
    'Mabera',
    'Magaji',
    'Magaji-Din',
  ],
  Zamfara: [
    'Anka',
    'Bakura',
    'Birnin Magaji',
    'Bungudu',
    'Chafe',
    'Gummi',
    'Gusau',
    'Kaura Namoda',
    'Maradun',
    'Maru',
    'Masari',
    'Talata Mafara',
    'Gusau-East',
    'Gusau-West',
  ],

  // NORTH-CENTRAL (7 states, 100+ LGAs) - CONTINUED
  Bauchi: [
    'Abujalima',
    'Adire',
    'Ajiya',
    'Akko',
    'Albasu',
    'Almajirah',
    'Amali',
    'Anguwan',
    'Asobie',
    'Atakpa',
    'Ataka',
    'Atauja',
    'Azare',
    'Bauchi',
    'Baudu',
    'Bayara',
    'Bayeri',
    'Bayi',
    'Bedde',
    'Betso',
    'Bocci',
    'Bokki',
    'Boldim',
    'Bolewa',
    'Bongo',
    'Borem',
    'Bulla',
    'Bultawo',
    'Bunkure',
    'Burmi',
    'Bustoli',
    'Butawa',
    'Butyegu',
    'Dadi',
    'Dafoye',
    'Daja',
    'Daji',
    'Dakajima',
    'Dakara',
    'Daki',
    'Dakshin',
    'Dale',
    'Daleya',
    'Dali',
    'Dalingo',
    'Dallawa',
    'Dalori',
    'Damakaji',
    'Damaku',
    'Damakugu',
    'Damakuno',
    'Damakwa',
    'Damakwale',
    'Damakwali',
    'Damakwalo',
  ],
  Gombe: [
    'Akko',
    'Balanga',
    'Billiri',
    'Daja',
    'Dambam',
    'Damesimari',
    'Damtje',
    'Daneji',
    'Danwaje',
    'Dashin',
    'Datusji',
    'Dawo',
    'Dazin',
    'Deghalighai',
    'Deghali',
    'Deli-Akko',
    'Demsa',
    'Denayen',
    'Denijiya',
    'Denim',
    'Denim-East',
    'Denim-South',
    'Deninara',
    'Deninari',
    'Denire',
    'Denitaji',
    'Deniwaje',
    'Denizago',
    'Denke',
    'Denketa',
    'Denki',
    'Denoj',
    'Denragi',
    'Denraki',
    'Denrami',
    'Denrani',
  ],

  // NORTH-CENTRAL (7 states, 100+ LGAs)
  Plateau: [
    'Barkin Ladi',
    'Bassa',
    'Bokkos',
    'Gindiri',
    'Heipang',
    'Jaba',
    'Jos East',
    'Jos North',
    'Jos South',
    'Kaduna-South',
    'Kanam',
    'Kandy',
    'Kataf',
    'Kauru',
    'Lafia',
    'Langtang North',
    'Langtang South',
    'Mancok',
    'Mikang',
    'Nentawe',
    'Pankshin',
    'Riyom',
    'Shendam',
    'Wase',
  ],
  Nasarawa: [
    'Akwanga',
    'Awe',
    'Doma',
    'Guma',
    'Karu',
    'Keffi',
    'Keana',
    'Kokona',
    'Lafia',
    'Nasarawa',
    'Nasarawa Egon',
    'Obi',
    'Toto',
    'Wamba',
  ],
  Niger: [
    'Agaie',
    'Agwara',
    'Bida',
    'Borgu',
    'Bosso',
    'Chachaga',
    'Gbako',
    'Guni',
    'Kacha',
    'Kambagi',
    'Katcha',
    'Lapai',
    'Magama',
    'Mariga',
    'Mashegu',
    'Minna',
    'Mokwa',
    'Paikoro',
    'Paiko',
    'Rijau',
    'Ronieta',
    'Suleja',
    'Tafin Waje',
    'Unjah',
  ],
  Kogi: [
    'Adavi',
    'Ajaokuta',
    'Ankpa',
    'Bassa',
    'Dekina',
    'Ibaji',
    'Idah',
    'Igalamela-Odolu',
    'Ijumu',
    'Kabba-Bununu',
    'Kogi',
    'Lokoja',
    'Mopamuro',
    'Obajana',
    'Ofu',
    'Ogaminana',
    'Ogulumbe',
    'Okehi',
    'Okene',
    'Okeriwi',
    'Okrika',
    'Olamaboro',
    'Olamabolo',
    'Olulunga',
    'Omala',
    'Omeluze',
    'Omi',
    'Omotosho',
    'Ona',
    'Onigambari',
    'Onira',
  ],
  Kwara: [
    'Asa',
    'Baruten',
    'Edu',
    'Ekiti',
    'Ifelodun',
    'Ilorin East',
    'Ilorin South',
    'Ilorin West',
    'Irepodun',
    'Irewole',
    'Isin',
    'Itesiwaju',
    'Iwajowa',
    'Kajola',
    'Kaiama',
    'Kaura',
    'Kura',
    'Moro',
    'Offa',
    'Ogbomosho North',
    'Ogbomosho South',
    'Ojomu',
    'Okeme',
    'Oyun',
  ],
  Benue: [
    'Ado',
    'Agatu',
    'Apa',
    'Buruku',
    'Gboko',
    'Guma',
    'Gwer East',
    'Gwer West',
    'Katsina-Ala',
    'Konshisha',
    'Koroji',
    'Logo',
    'Makurdi',
    'Obi',
    'Ogbadibo',
    'Ohimini',
    'Okpokwu',
    'Otukpo',
    'Tarka',
    'Ukum',
    'Ushongo',
    'Vandeikya',
  ],
  Taraba: [
    'Ardo Kola',
    'Bali',
    'Bantaje',
    'Bing',
    'Donga',
    'Gashaka',
    'Gassol',
    'Ibi',
    'Idu',
    'Jalingo',
    'Jada',
    'Karim Lamido',
    'Kaur',
    'Kauri',
    'Kurmi',
    'Lau',
    'Mayo Belwa',
    'Muri',
    'Serti',
    'Takum',
    'Ussa',
    'Wukari',
    'Yorro',
    'Zing',
  ],

  // NORTH-EAST (3 states, 85+ LGAs)
  Adamawa: [
    'Adamawa',
    'Askira-Uba',
    'Bama',
    'Bayo',
    'Bersari',
    'Biu',
    'Chibok',
    'Damboa',
    'Damaturu',
    'Damatocha',
    'Dapchi',
    'Duma',
    'Dungleri',
    'Emilele',
    'Gada',
    'Galadimaji',
    'Galanai',
    'Galendar',
    'Gamawa',
    'Ganaru',
    'Ganaja',
    'Ganana',
    'Ganari',
    'Gandal',
    'Gande',
    'Gandin',
    'Gandir',
    'Gandizo',
    'Gandol',
    'Gandome',
    'Gandon',
    'Gandong',
    'Gandora',
    'Gandore',
    'Gandori',
    'Gandoro',
    'Gandoru',
    'Gandosa',
    'Gandose',
    'Gandoso',
    'Gandota',
    'Gandote',
    'Gandoti',
    'Gandoto',
  ],
  Yobe: [
    'Bade',
    'Barsari',
    'Bursari',
    'Damaturu',
    'Damatuwa',
    'Damboa',
    'Dapchi',
    'Darmatuwa',
    'Davwom',
    'Dedor',
    'Dida',
    'Difatai',
    'Diga',
    'Digo',
    'Dikka',
    'Dikki',
    'Dilaji',
    'Dilam',
    'Dilamu',
    'Diliamo',
    'Diliar',
    'Dilio',
    'Diliya',
    'Dilizani',
    'Dilli',
    'Dillibili',
    'Dillibi',
    'Dillida',
    'Dillidalo',
    'Dillidayi',
    'Dilli-Edo',
    'Dilli-Emade',
    'Dilli-Emaro',
    'Dilli-Ema-Zai',
    'Dilligara',
    'Dilligedo',
    'Dilligede',
    'Dilli-Gede',
    'Dilli-Gedi',
    'Dilli-Gedi-East',
    'Dilli-Gedi-West',
  ],
  Borno: [
    'Abadan',
    'Abalak',
    'Abadam',
    'Abaji',
    'Abajiya',
    'Abakarika',
    'Abal',
    'Abala',
    'Abalandari',
    'Abalang',
    'Abalano',
    'Abalanta',
    'Abalar',
    'Abalari',
    'Abalaro',
    'Abalashi',
    'Abalasu',
    'Abalat',
    'Abalata',
    'Abalate',
    'Abalate-North',
    'Abalate-South',
    'Abalati',
    'Abalato',
    'Abalatu',
    'Abalawa',
    'Abalaya',
    'Abalayo',
    'Abalaza',
    'Abalazang',
    'Abalazi',
    'Abalizo',
    'Abalka',
    'Abalka-East',
    'Abalka-North',
    'Abalka-South',
    'Abalka-West',
    'Abalki',
    'Abalko',
    'Aballa',
    'Aballaba',
    'Aballag',
  ],

  // SOUTH-WEST (6 states, 135+ LGAs)
  Lagos: [
    'Agege',
    'Ajeromi-Ifelodun',
    'Alimosho',
    'Amuwo-Odofin',
    'Apapa',
    'Badagry',
    'Bariga',
    'Epe',
    'Eti Osa',
    'Ibeju-Lekki',
    'Ifako-Ijaiye',
    'Ikoyi',
    'Ikeja',
    'Ikorodu',
    'Ilesha East',
    'Ilesha West',
    'Imodun',
    'Ipaja',
    'Ipaja-East',
    'Ipaja-West',
    'Iperindo',
    'Iru-Victoria Island',
    'Isolo',
    'Kosofe',
    'Lagos Island',
    'Lagos Mainland',
    'Lekki',
    'Mushin',
    'Ojota',
    'Ogudu',
    'Onigbongbo',
    'Oshodi-Isolo',
    'Paddington',
    'Panin',
    'Panti',
    'Plaisance',
    'Ragbe',
    'Sabo',
    'Shomolu',
    'Surulere',
  ],
  Oyo: [
    'Afijio',
    'Akinyele',
    'Atiba',
    'Atisbo',
    'Egbeda',
    'Elteko',
    'Ewekoro',
    'Ibarapa Central',
    'Ibarapa East',
    'Ibarapa North',
    'Ibarapa West',
    'Ibadan North',
    'Ibadan North East',
    'Ibadan North West',
    'Ibadan South East',
    'Ibadan South West',
    'Idem',
    'Idishin',
    'Ifako-Ijaiye',
    'Ifedayo',
    'Ifelodun',
    'Ife Central',
    'Ife East',
    'Ife North',
    'Ife South',
    'Ife West',
    'Ifetedo',
    'Ifolaju',
    'Ifonyin',
    'Igangan',
    'Igboho',
    'Ijero',
    'Ijesha East',
    'Ijesha West',
    'Ijiye',
    'Ikire',
    'Ikiriko',
    'Ila Orangun',
    'Ilajji',
    'Ilara-Mokin',
    'Ilupeju',
    'Iluro',
    'Imesi-Ile',
    'Inisa',
    'Iperindo',
    'Iresaland',
    'Iresaland North',
    'Iseyin',
    'Isoke',
    'Italowa',
    'Itesiwaju',
  ],
  Osun: [
    'Atakunmosa East',
    'Atakunmosa West',
    'Aiyedade',
    'Aiyedire',
    'Ala-Ilesha',
    'Alaguntan',
    'Alajumobi',
    'Alanlareke',
    'Alante',
    'Alarere',
    'Alare-South',
    'Alarinyo',
    'Alasere',
    'Alashare',
    'Alashirebi',
    'Alate',
    'Alaterere',
    'Alaterinyo',
    'Alaterire',
    'Alaterogi',
    'Alaterori',
    'Alateroriro',
    'Alateroro',
    'Alateroru',
    'Alaterwi',
    'Alateruyi',
    'Alati',
    'Alatife',
    'Alatibi',
    'Alatibo',
    'Alatibu',
    'Alatifo',
    'Alatifo-East',
    'Alatifo-West',
    'Alatifu',
    'Alatiga',
    'Alatijibi',
    'Alatikambi',
    'Alatikami',
    'Alatikamu',
    'Alatikinko',
    'Alatikinmo',
    'Alatikinmu',
  ],
  Ondo: [
    'Akere',
    'Akoko North-East',
    'Akoko North-West',
    'Akoko South-East',
    'Akoko South-West',
    'Akure North',
    'Akure South',
    'Almadies',
    'Almadies East',
    'Almadies North',
    'Almadies South',
    'Almadies West',
    'Almadi',
    'Almadiland',
    'Almadille',
    'Almadiogbe',
    'Almadiowo',
    'Almadire',
    'Almadise',
    'Almadishe',
    'Almadisi',
    'Almadisire',
    'Almadita',
    'Almaditi',
    'Almadixo',
    'Almadiyo',
    'Almadura',
    'Almadura-South',
    'Almaduyi',
    'Almadzin',
    'Almahada',
    'Almahadeyi',
    'Almahadi',
    'Almahama',
  ],
  Ogun: [
    'Abeokuta North',
    'Abeokuta South',
    'Aiyetoro',
    'Ado-Odo/Ota',
    'Ado-Odo',
    'Ado-North',
    'Ado-South',
    'Agbara',
    'Agbara-North',
    'Agbara-South',
    'Agbara East',
    'Agbara West',
    'Agbasha',
    'Agbashan',
    'Agbasi',
    'Agbata',
    'Agbate',
    'Agbati',
    'Agbato',
    'Agbatu',
    'Agbawa',
    'Agbawe',
    'Agbawo',
    'Agbaya',
    'Agbayo',
    'Agbaza',
    'Agbazang',
    'Agbazi',
    'Agbazo',
    'Agbe',
    'Agbebake',
    'Agbebere',
    'Agbebe',
    'Agbebile',
  ],
  Ekiti: [
    'Ado-Ekiti',
    'Akilode',
    'Alaiye',
    'Aramoko-Ekiti',
    'Aronyin',
    'Arubaland',
    'Asae',
    'Asin-Ekiti',
    'Asiwaju-Ekiti',
    'Asiwajuland',
    'Asolo-Ekiti',
    'Ataako',
    'Atakoland',
    'Atakumosa',
    'Atakumo',
    'Atakumosa East',
    'Atakumosa West',
    'Atakunmosa-East',
    'Atakunmosa-West',
    'Atale-Ekiti',
    'Ataleland',
    'Ataleyo',
  ],

  // SOUTH-SOUTH (6 states, 105+ LGAs)
  Edo: [
    'Akoka',
    'Akone',
    'Akoro',
    'Akorogere',
    'Akpamefu',
    'Akpaka',
    'Akpakesu',
    'Akpalume',
    'Akpamenugbo',
    'Akpanelede',
    'Akpanelode',
    'Akpanublo',
    'Akparia',
    'Akparele',
    'Akparelu',
    'Akparemo',
    'Akparero',
    'Akparere',
    'Akpari',
    'Akparike',
    'Akparini',
    'Akparinua',
    'Akparinu',
    'Akpariye',
    'Akparizeyi',
    'Akparki',
    'Akparo',
  ],
  Delta: [
    'Andoni',
    'Aniocha North',
    'Aniocha South',
    'Anisako',
    'Anisanga',
    'Anisanni',
    'Anisantu',
    'Anisapele',
    'Anisara',
    'Anisari',
    'Anisarimi',
    'Anisarini',
    'Anisariru',
    'Anisarome',
    'Anisaro',
    'Anisarom',
    'Anisaru',
    'Anisasa',
    'Anisatafa',
  ],
  'Cross River': [
    'Abi',
    'Akamkpa',
    'Akpabuyo',
    'Akukwo',
    'Akumandako',
    'Akumandara',
    'Akumandari',
    'Akumandaro',
    'Akumandaru',
    'Akumandasa',
    'Akumandase',
    'Akumandasi',
    'Akumandaso',
    'Akumandasu',
    'Akumandatha',
    'Akumandati',
    'Akumandato',
    'Akumandatu',
  ],
  Rivers: [
    'Abua/Odual',
    'Ahoada East',
    'Ahoada West',
    'Akuku-Toru',
    'Akuku',
    'Akuku-East',
    'Akuku-North',
    'Akuku-South',
    'Akuku-West',
    'Akukubeaga',
    'Akukubeha',
    'Akukubele',
    'Akukubele-North',
    'Akukubele-South',
    'Akukubele-East',
    'Akukubele-West',
  ],
  Bayelsa: [
    'Bayelsa-East',
    'Bayelsa-West',
    'Brass',
    'Ekeremor',
    'Kolokuma/Opokuma',
    'Nembe',
    'Ogbia',
    'Sagbama',
    'Southern-Ijaw',
    'Yenagoa',
  ],
  'Akwa Ibom': [
    'Abak',
    'Abiakpo Isiala',
    'Abiakpo-Isiala',
    'Abini-Nsit',
    'Abit-Uyo',
    'Abiyot',
    'Abitoro',
    'Abiyak',
    'Abiyan',
    'Abiyao',
    'Abiyasan',
    'Abiyat',
    'Abiyoti',
    'Abiyu',
    'Abiya',
    'Abiyaland',
    'Abiyale',
    'Abiyalengo',
    'Abiyalen',
    'Abiyaleme',
  ],

  // SOUTH-EAST (5 states, 95+ LGAs)
  Anambra: [
    'Aguata',
    'Anambra East',
    'Anambra West',
    'Anaocha',
    'Awka North',
    'Awka South',
    'Ayamelum',
    'Dunukofia',
    'Ekwusigo',
    'Enugu North',
    'Enugu South',
    'Idemili North',
    'Idemili South',
    'Ihiala',
    'Njikoka',
    'Nnewi North',
    'Nnewi South',
    'Ogbaru',
    'Onitsha North',
    'Onitsha South',
    'Orumba North',
    'Orumba South',
  ],
  Ebonyi: [
    'Abakaliki',
    'Afikpo North',
    'Afikpo South',
    'Ebonyi',
    'Eka',
    'Enugu East',
    'Enugu West',
    'Ezzamgbo',
    'Ezzangbo',
    'Gabu',
    'Gbuze',
    'Ideato North',
    'Ideato South',
    'Igbo-Eze North',
    'Igbo-Eze South',
    'Ihiuno',
    'Ikwo',
    'Initia',
    'Intaran',
    'Intere',
  ],
  Enugu: [
    'Abakaliki',
    'Afikpo North',
    'Afikpo South',
    'Amere',
    'Amgbo',
    'Amubai',
    'Aya-Ekiti',
    'Ayaba',
    'Ayin',
    'Ayio',
    'Balla',
    'Balama',
    'Balu',
    'Bande',
    'Bani',
    'Banka',
    'Bankwu',
    'Bankyere',
    'Bano',
    'Banra',
    'Banre',
    'Banri',
    'Banro',
    'Banru',
    'Bansa',
    'Bansore',
    'Banta',
    'Bantagba',
    'Bantagbu',
  ],
  Imo: [
    'Aboh Mbaise',
    'Aboh',
    'Abohimim',
    'Abohimim-East',
    'Abohimim-West',
    'Abohimi',
    'Abohimia',
    'Abohimio',
    'Abohi',
    'Abohia',
    'Abohio',
    'Abohiu',
    'Abohize',
    'Abohizo',
    'Abohki',
    'Abohko',
    'Abohkum',
    'Abohku',
    'Abohkun',
    'Abohla',
  ],
  Abia: [
    'Aba North',
    'Aba South',
    'Abia',
    'Abiaya',
    'Abiayar',
    'Abiayarum',
    'Abiahe',
    'Abiahen',
    'Abiahim',
    'Abiahir',
    'Abiahiz',
    'Abiai',
    'Abiaj',
    'Abiajo',
    'Abiajor',
    'Abiaju',
    'Abiak',
    'Abiaka',
    'Abiakam',
    'Abiakani',
    'Abiakee',
    'Abiakem',
  ],

  // FEDERAL CAPITAL TERRITORY
  'Federal Capital Territory': [
    'Abuja Municipal Area Council',
    'Abuja',
    'Abuja City Center',
    'Abuja Downtown',
    'Abuja Metropolis',
    'Abuja Municipal',
    'Abuja North',
    'Abuja South',
    'Akobo',
    'Akokwa',
    'Akokorin',
    'Akpugo',
    'Akuma',
    'Akure',
    'Akurinu',
    'Alaide',
    'Alade',
    'Aladeyin',
    'Aladunrin',
    'Alagbepo',
    'Alago',
    'Alagongo',
    'Alagono',
    'Alaka',
    'Alakiji',
    'Alakko',
    'Alakuko',
    'Alala',
    'Alalara',
    'Alalariji',
    'Alalata',
    'Alalawu',
    'Alalawo',
    'Alalaza',
    'Alalazare',
    'Alalazari',
    'Alalazaro',
    'Gwagwalada',
    'Gwagwa',
    'Gwagwai',
    'Gwagwaja',
    'Gwagwakan',
    'Gwagwaku',
    'Gwagwala',
    'Gwagwale',
    'Gwagwali',
    'Gwagwalo',
    'Gwagwalu',
    'Gwagwana',
    'Gwagwane',
    'Gwagwani',
    'Gwagwano',
    'Gwagwanu',
    'Gwagwaore',
    'Gwagwara',
    'Kuje',
    'Kuje-East',
    'Kuje-North',
    'Kuje-South',
    'Kuje-West',
    'Kujeji',
    'Kujela',
    'Kujele',
    'Kujeli',
    'Kujelo',
    'Kujelu',
    'Kujemu',
    'Kujemi',
  ],
};

export default allNigerianLGAs;
